import wrapText from './wrapText.js';


export default async function renderDesign(design, divEl, i,firstpass, fontComboIndex, separator) {


const themes=[
 // {id:"greenPink", background: "#2B4743", primaryText: "#FFD3DB", secondaryText: "#FFD3DB"},
 // {id:"beigeGray", background: "#FFFCF7", primaryText: "#171717", secondaryText: "#171717"},
 // {id:"pink", background: "#FFE9E1", primaryText: "#FD7080", secondaryText: "#000000"},
 // {id:"beigePink", background: "#E4E2DD", primaryText: "#E18999", secondaryText: "#000000"},


    {id:"white", background: "#FFFFFFFF", primaryText: "#000000FF", secondaryText: "#000000FF"},
  // {id:"white", background: "#FFFFFFFF", primaryText: "#1a1a1a", secondaryText: "#1a1a1a", tiFont: "Nunito Sans", stiFont:"Nunito Sans", auFont:"Nunito Sans"},


  // {id:"lightBlue",background: "#89ABE3FF", primaryText: "#FCF6F5FF", secondaryText: "#FCF6F5FF"},//lightblue
   // {id:"slate",background: "#272b30", primaryText: "#aaa", secondaryText: "#aaa",  tiFont: "Roboto", stiFont:"Roboto", auFont:"Roboto"},

    //{id:"yellow",background: "#FEE715FF", primaryText: "#101820FF", secondaryText: "#101820FF"},
//    {id:"quartz",background: "#e83283", primaryText: "#33b7e2", secondaryText: "white",  tiFont: "Oswald", stiFont:"Quattrocento", auFont:"Quattrocento"},

 //   {id: "blackOrange", background: "#101820FF", primaryText: "#F2AA4CFF", secondaryText: "#F2AA4CFF"},
    {id: "black", background: "dark", primaryText: "white", secondaryText: "white"},
   // {id: "Orange", background: "#f4b41a", primaryText: "#143d59", secondaryText: "white"},//orage
 //   {id: "blueFromCanvasIthink", background: "#e4e2dd", primaryText: "#6994c6", secondaryText: "#6994c6"},//bluefromcanva
  //  {id: "fromCanva", background: "#e6e6e6", primaryText: "#4b4646", secondaryText: "#4b4646"},//from canva

   // {id: "cyborg", background: "#060606", primaryText: "#2a9fd6", secondaryText: "white",  tiFont: "Roboto", stiFont:"Roboto", auFont:"Roboto"},
   // {id: "white", background: "white", primaryText: "#555555", secondaryText: "#555555", tiFont: "'Cabin Sketch', cursive", stiFont:"Neucha", auFont:"Neucha"},
    //slate above
];

var canvas = document.createElement('canvas');

canvas.id = "designCanvas"+i;
canvas.width = design.canvasWidth;
canvas.height = design.canvasHeight;
canvas.className="border border-warning border-0"
//for safari
canvas.style="width: 100%;height: auto"
divEl.appendChild(canvas);

canvas = document.getElementById("designCanvas"+i);
var ctx = canvas.getContext("2d");
var background=design;
background.designId="designCanvas"+i;






/*const colorThief = new ColorThief();

const images=galleryImages.filter( (e) => e.fileName && e.fileName.slice(0,6)!=='square' && e.fileName.slice(0,8)!=='portrait');
var imgSrc=images[Math.floor(Math.random() * images.length)].fileName;
let img = await loadImage('/gallery/'+imgSrc);
const colors=colorThief.getColor(img);
console.log(colors);
background.imageWidth=img.width;
background.imageHeight=img.height;

//const colorIndex=Math.floor(Math.random()*colors.length);
const r=colors[0];
const g=colors[1];
const b=colors[2];

var theme={};
if (r+g+b > 300) {
theme=themes[0];
} else theme=themes[1];
*/

const theme=themes[Math.floor(Math.random()*themes.length)];//themeIndex];
design.theme=theme.id;
ctx.beginPath();


ctx.fillStyle=theme.background;
ctx.fillRect(0,0, background.canvasWidth, background.canvasHeight);

//console.log(img.src);


const w = canvas.width;
const h = canvas.height;

if (!firstpass && (theme.id=="white" || theme.id=="black")) {

  const coloursB= ["#BABFD1", "#E8E9ED","#f9d5e5","#ffeead","#96ceb4"];//last 5 are orig "#6EB4DC","#FAF0D2", "#C8D2AA",
  const coloursW = [ "#FF7B9C", "#607196","#feb236","#b2ad7f","#034f84"];// last 5 are orig "#A0826E","#9664FA","#646478",
  const numElements=Math.floor(Math.random()*[10,100,500][Math.floor(Math.random()*3)]);
  var fillStroke=Math.random();
  var x = Math.random();

  //var numColors=Math.floor(Math.random()*5);
  var size = Math.random()*([10,100,1000][Math.floor(Math.random()*3)]);//100
  var radius = Math.random()*([10,100,1000][Math.floor(Math.random()*2)]); //300 slightly smaller than half the size

  if (fillStroke <=0.5) {
    if (theme.id=="white") {
      ctx.fillStyle = coloursB[Math.floor(coloursB.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

    } else if (theme.id=="black") {
      ctx.fillStyle = coloursW[Math.floor(coloursW.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

    }
  } else {
      if (theme.id=="white") {
        ctx.strokeStyle = coloursB[Math.floor(coloursB.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];
      } else if (theme.id=="black") {
        ctx.strokeStyle = coloursW[Math.floor(coloursW.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

      }
  }
  
  for (let c = 0; c < numElements; c++) {

  if (x<=0.4) {   
  size = Math.random()*([10,100,1000][Math.floor(Math.random()*2)]);//100
  radius = Math.random()*([10,100,1000][Math.floor(Math.random()*2)]); //300 slightly smaller than half the size

  if (fillStroke <=0.5) {
    if (theme.id=="white") {
      ctx.fillStyle = coloursB[Math.floor(coloursB.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

    } else if (theme.id=="black") {
      ctx.fillStyle = coloursW[Math.floor(coloursW.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

    }
  } else {
      if (theme.id=="white") {
        ctx.strokeStyle = coloursB[Math.floor(coloursB.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];
      } else if (theme.id=="black") {
        ctx.strokeStyle = coloursW[Math.floor(coloursW.length * Math.random())];//"rgb("+r+","+g+","+b+")";//colours[Math.floor(colours.length * Math.random())];

      }
  }
}  

    ctx.beginPath();

    if (x < 0.33) {
      radius=Math.random()*([10,100,1000][Math.floor(Math.random()*2)]);
      ctx.ellipse(
        Math.random()*w,//(c + 0.5) * size, // centre of column
        Math.random()*h,//(r + 0.5) * size, // centre of row
        radius,
        radius,
        0,
        0,
        2 * Math.PI
      );
    } else if (x < 0.66 && x >= 0.33) {
      ctx.rect(Math.random()*w,Math.random()*h, Math.random()*size,Math.random()*size);
    } else {
      ctx.rect(Math.random()*w, Math.random()*h, Math.random()*size, Math.random()*h);
    }

    if (fillStroke <=0.5) {
      ctx.fill();
    } else {
      ctx.stroke();
    }
  }  
}



	//ctx.drawImage(img, design.imgX, design.imgY, img.width/img.height*design.imgH, design.imgH);//, img.height);

  //drawImageProp(ctx,img, design.imgX, design.imgY, design.imgW, design.imgH);

//img.src='/gallery/'+imgSrc;


var ti=background.ti;//title.title.trim();

ctx.textAlign = background.tiAlign;
ctx.fillStyle=theme.primaryText;
//ctx.textBaseline=background.tiDirection;
//background.tiFont=background.tiFont;//fontCombo.tiFont;
//background.stiFont=background.stiFont;//fontCombo.stiFont;
//background.auFont=background.auFont;//fontCombo.auFont;
ctx.letterSpacing = "0px";
background.tiLineHeight=background.tiFontSize+0;
background.stiLineHeight=background.stiFontSize+0;

if (background.tiFontEffect=='regular') {
  ctx.font = background.tiFontSize+'px '+background.tiFont;
} else {
  ctx.font = background.tiFontEffect+' '+background.tiFontSize+'px '+background.tiFont;
}








//var tiNumLines=textArranger(ctx, ti, background.tiFontSize, background.tiX, background.tiY, background.tiWidth, background.tiHeight, background.tiDirection, background.tiAlign, ' ', 5);

//console.log(background.tiX, background.tiY, background.tiWidth, background.tiFontSize, background.tiDirection, background.tiAlign, background.tiHeight);


//ctx.strokeRect(background.tiX,background.tiY, background.tiWidth, background.tiHeight);
ctx.letterSpacing = design.tiLetterSpacing+"px";

var tiLines, tiMetricWidths=[], tiMetricHeights=[], tiLineLenghts=[];

var tiHFactor=design.tiLineSpacingFactor;
[background.tiNumLines, background.tiMaxLineWidth, tiLines, tiMetricWidths, tiMetricHeights, tiLineLenghts]=wrapText(ctx, ti, design.lines, background.tiX, background.tiY, background.tiWidth, background.tiLineHeight*tiHFactor, background.tiDirection, background.tiAlign, background.tiHeight, ' ');

ctx.letterSpacing = design.stiLetterSpacing+"px";

//ctx.letterSpacing = "0px";

var sti=background.sti;//title.subtitle.trim();

ctx.textAlign = background.stiAlign;
ctx.fillStyle=theme.secondaryText;
//ctx.textBaseline=background.stiDirection;
//ctx.letterSpacing = "5px";

var stiLines=['','','','',''], stiMetricWidths=[0,0,0,0,0], stiMetricHeights=[0,0,0,0,0],  stiLineLenghts=[];

  if (sti.length > 0) {

if (background.stiFontEffect=='regular') {
  ctx.font = background.stiFontSize+'px '+background.stiFont;
} else {
  ctx.font = background.stiFontEffect+' '+background.stiFontSize+'px '+background.stiFont;
}

//var stiNumLines=textArranger(ctx, sti, background.tiFontSize/1.98, background.stiX, background.stiY, background.stiWidth, background.stiHeight, background.stiDirection, background.stiAlign, ' ', 2);
//var tempStiY=background.stiY;
//background.stiY=background.tiY+background.tiNumLines*background.tiFontSize;
//background.stiHeight=background.stiHeight-(tempStiY-background.stiY);
//ctx.strokeRect(background.stiX,background.stiY, background.stiWidth, background.stiHeight);


  if (background.ti_sti_close==1) {
    background.stiY=background.tiY+background.tiFontSize*(background.lines.length-1)*tiHFactor+background.tiFontSize*tiHFactor;//background.tiFontSize*0.1;
  }
  if (background.sti_au_close==0) {
    [background.stiNumLines, background.stiMaxLineWidth, stiLines, stiMetricWidths,stiMetricHeights, stiLineLenghts]=wrapText(ctx, sti, [], background.stiX, background.stiY, background.stiWidth, background.stiLineHeight*background.stiLineSpacingFactor, background.stiDirection, background.stiAlign, background.stiHeight, ' ');
  }
 // background.stiStd=getStandardDeviation(stiLineLenghts);

  }
  /*var realsTiH=background.stiNumLines*background.stiFontSize;

  background.stiLine0=stiLines[0] ? stiLines[0] : '';
  background.stiMetricWidth0=stiMetricWidths[0] ? stiMetricWidths[0] : 0;

  background.stiLine1=stiLines[1] ? stiLines[1] : '';
  background.stiMetricWidth1=stiMetricWidths[1] ? stiMetricWidths[1] : 0;

  background.stiLine2=stiLines[2] ? stiLines[2] : '';
  background.stiMetricWidth2=stiMetricWidths[2] ? stiMetricWidths[2] : 0;


  background.stiLine3=stiLines[3] ? stiLines[3] : '';
  background.stiMetricWidth3=stiMetricWidths[3] ? stiMetricWidths[3] : 0;

  background.stiLine4=stiLines[4] ? stiLines[4] : '';
  background.stiMetricWidth4=stiMetricWidths[4] ? stiMetricWidths[4] : 0;

  background.stiLine5=stiLines[5] ? stiLines[5] : '';
  background.stiMetricWidth5=stiMetricWidths[5] ? stiMetricWidths[5] : 0;*/


/*var totalH=realTiH+realsTiH+background.p*design.canvasHeight/2;
background.tiY=background.canvasHeight/2-totalH/2;
background.tiHeight=realTiH;
background.stiY=background.tiY+realTiH+background.p*design.canvasHeight/2;
background.stiHeight=realsTiH;

ctx.textAlign = background.tiAlign;
ctx.fillStyle=theme.primaryText;
ctx.textBaseline=background.tiDirection;
background.tiFont=background.tiFont;//fontCombo.tiFont;
background.stiFont=background.stiFont;//fontCombo.stiFont;
background.auFont=background.auFont;//fontCombo.auFont;
//ctx.letterSpacing = "5px";

if (background.tiFontEffect=='regular') {
  ctx.font = background.tiFontSize+'px '+background.tiFont;
} else {
  ctx.font = background.tiFontEffect+' '+background.tiFontSize+'px '+background.tiFont;
}

[background.tiNumLines, background.tiMaxLineWidth, tiLines, tiMetricWidths, tiMetricHeights]=wrapText(ctx, ti, background.tiX, background.tiY, background.tiWidth, background.tiLineHeight, background.tiDirection, background.tiAlign, background.tiHeight, ' ');



ctx.textAlign = background.stiAlign;
ctx.fillStyle=theme.secondaryText;
ctx.textBaseline=background.stiDirection;


if (background.stiFontEffect=='regular') {
  ctx.font = background.stiFontSize+'px '+background.stiFont;
} else {
  ctx.font = background.stiFontEffect+' '+background.stiFontSize+'px '+background.stiFont;
}
[background.stiNumLines, background.stiMaxLineWidth, stiLines, stiMetricWidths]=wrapText(ctx, sti, background.stiX, background.stiY, background.stiWidth, background.stiLineHeight, background.stiDirection, background.stiAlign, background.stiHeight, ' ');

*/
ctx.letterSpacing = design.auLetterSpacing+"px";

//ctx.letterSpacing = "0px";

var au=background.au;
ctx.textAlign = background.auAlign;
ctx.fillStyle=theme.primaryText;
var auLines=['','','','',''], auMetricWidths=[0,0,0,0,0], auLineLengths=[];

  if (au.length > 0) {


if (background.auFontEffect=='regular') {
  ctx.font = background.auFontSize+'px '+background.auFont;
} else {
  ctx.font = background.auFontEffect+' '+background.auFontSize+'px '+background.auFont;
}
//ctx.strokeRect(background.auX,background.auY, background.auWidth, background.auHeight);

//var auNumLines=textArranger(ctx, au, background.auFontSize, background.auX, background.auY, background.auWidth, background.auHeight, background.auDirection, background.auAlign, ', ',20);

 [background.auNumLines, background.auMaxLineWidth, auLines, auMetricWidths, auLineLengths]=wrapText(ctx, au, [], background.auX, background.auY, background.auWidth, background.auFontSize*background.auLineSpacingFactor, background.auDirection, background.auAlign, background.auHeight, ', ');
 //background.auStd=getStandardDeviation(auLineLengths);


if (background.sti_au_close==1) {
  ctx.letterSpacing = design.stiLetterSpacing+"px";

  if (background.stiFontEffect=='regular') {
  ctx.font = background.stiFontSize+'px '+background.stiFont;
} else {
  ctx.font = background.stiFontEffect+' '+background.stiFontSize+'px '+background.stiFont;
}
  background.stiY=background.auY+background.auHeight-background.auFontSize*(background.auNumLines-1)*background.auLineSpacingFactor-background.auFontSize*background.auLineSpacingFactor-background.stiHeight-12;

  [background.stiNumLines, background.stiMaxLineWidth, stiLines, stiMetricWidths,stiMetricHeights, stiLineLenghts]=wrapText(ctx, sti, [], background.stiX, background.stiY, background.stiWidth, background.stiLineHeight*background.stiLineSpacingFactor, background.stiDirection, background.stiAlign, background.stiHeight, ' ');
 //
}

  }

  /*background.auLine0=auLines[0] ? auLines[0] : '';
  background.auMetricWidth0=auMetricWidths[0] ? auMetricWidths[0] : 0;
 
  background.auLine1=auLines[1] ? auLines[1] : '';
  background.auMetricWidth1=auMetricWidths[1] ? auMetricWidths[1] : 0;
 
  background.auLine2=auLines[2] ? auLines[2] : '';
  background.auMetricWidth2=auMetricWidths[2] ? auMetricWidths[2] : 0;
 
 
  background.auLine3=auLines[3] ? auLines[3] : '';
  background.auMetricWidth3=auMetricWidths[3] ? auMetricWidths[3] : 0;
 
  background.auLine4=auLines[4] ? auLines[4] : '';
  background.auMetricWidth4=auMetricWidths[4] ? auMetricWidths[4] : 0;
 
  background.auLine5=auLines[5] ? auLines[5] : '';
  background.auMetricWidth5=auMetricWidths[5] ? auMetricWidths[5] : 0;*/
//console.log(background);

return background;

}
